import React, { FunctionComponent, useState } from 'react';

import { ImageProps } from 'app/components/image';

import {
    StyledContainer,
    StyledImageContainer,
    StyledImage,
    StyledArrowColumn,
    StyledArrowLeft,
    StyledArrowRight,
    StyledNavigationItem,
    StyledNavigationRow,
} from './images-slider.styled';

interface Props {
    images: ImageProps[];
}

export const ImagesSlider: FunctionComponent<Props> = (props) => {
    const [selectedItem, setSelectedItem] = useState(0);
    const { images } = props;

    const handleSelectPrevious = (): void => setSelectedItem((previousState) => previousState - 1);
    const handleSelectNext = (): void => setSelectedItem((previousState) => previousState + 1);

    return (
        <StyledContainer>
            <StyledArrowColumn>
                {selectedItem !== 0 && <StyledArrowLeft onClick={handleSelectPrevious} />}
            </StyledArrowColumn>
            <StyledImageContainer>
                <StyledImage {...images[selectedItem]} />
                <StyledNavigationRow>
                    {images.map((image, index) => (
                        <StyledNavigationItem
                            key={index}
                            $active={index === selectedItem}
                            onClick={() => setSelectedItem(index)}
                        />
                    ))}
                </StyledNavigationRow>
            </StyledImageContainer>
            <StyledArrowColumn>
                {images.length - 1 !== selectedItem && <StyledArrowRight onClick={handleSelectNext} />}
            </StyledArrowColumn>
        </StyledContainer>
    );
};
